import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocalePath } from "../hooks/useLocalePath";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function BillingCancelPage() {
  const { t } = useTranslation();
  const lp = useLocalePath();

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="billing-cancel-page">
      <Card className="max-w-md w-full border-slate-200 shadow-md">
        <CardContent className="p-8 text-center">
          <XCircle className="h-12 w-12 text-slate-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-900 font-heading mb-2">{t("billing.cancelTitle")}</h1>
          <p className="text-sm text-slate-500 mb-6">{t("billing.cancelDesc")}</p>
          <Link to={lp("/pricing")}>
            <Button className="w-full bg-teal-700 hover:bg-teal-800 text-white font-medium" data-testid="billing-back-pricing">
              {t("billing.backToPricing")}
            </Button>
          </Link>
        </CardContent>
      </Card>
    </main>
  );
}
